'use client'

import { recordAcquisitionTouch } from '@/lib/posthog-attribution'
import { upsertUser } from '@/lib/roast/server'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { resolveChannelFromReferrerAndUtm } from './resolve-channel'

export function UtmTrackerClient() {
  const searchParams = useSearchParams()

  useEffect(() => {
    const referrer = window.document.referrer
    const aff = searchParams.get('aff')
    const ref = searchParams.get('ref')
    const utm_source = searchParams.get('utm_source')
    const utm_medium = searchParams.get('utm_medium')
    const utm_campaign = searchParams.get('utm_campaign')
    const utm_term = searchParams.get('utm_term')
    const utm_content = searchParams.get('utm_content')

    // Affiliate and referral
    if (aff) {
      localStorage.setItem('affiliateCode', JSON.stringify(aff))
    } else if (ref) {
      localStorage.setItem('referralCode', JSON.stringify(ref))
    }

    // Referrer fallback for links Meta/etc. didn't tag with UTM. Meta ad clicks
    // (incl. the FB/IG in-app browser) often arrive with only `fbclid` and no
    // utm_source, so they'd otherwise fall into Direct/Organic. We run no
    // organic Meta presence, so any FB/IG referral is paid Meta — standardize
    // on the `facebook/ads` convention for both so it rolls up as Meta.
    const utm = resolveChannelFromReferrerAndUtm({
      referrer,
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
    })

    // Send first-touch attribution + last-touch UTM to PostHog. Runs even
    // when `utm` is null so we still record the landing URL, referrer, and
    // country for direct/typed visits.
    recordAcquisitionTouch({
      utm: utm ?? null,
      referrer: referrer || null,
      searchParams,
    })

    if (!utm) return

    // Store dating app in local storage for funnel personalization
    if (utm?.utm_campaign === 'bumble') {
      localStorage.setItem('datingApp', JSON.stringify('bumble'))
    } else if (utm?.utm_campaign === 'hinge') {
      localStorage.setItem('datingApp', JSON.stringify('hinge'))
    }

    // Store UTM locally
    localStorage.setItem('utm', JSON.stringify(utm))

    // If email exists, upsert user with UTM
    const email = JSON.parse(localStorage.getItem('email') || 'null')

    if (email) {
      upsertUser({ email, utm })
    }
  }, [searchParams])

  return null
}

export default UtmTrackerClient
